var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.8333 62.4992C91.75 57.4992 93 52.0825 91.75 46.2492C89.25 37.9159 81.75 31.6659 73.4167 31.6659H68.4167C65.5 19.1659 55.0833 9.99924 42.5833 8.33257C30.0833 7.08257 18 13.7492 12.1666 24.9992C7.16665 35.4159 7.99998 52.0825 14.25 61.6659M50.5 54.9992V87.4992",
    stroke: "#2A2A2A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1667 66.6667L50.5 50L33.8333 66.6667",
    stroke: "#2A2A2A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.4bcb57e337811097b4b0b92dd3b4ad26.svg";
export { ForwardRef as ReactComponent };